import { ScreenScrapeStepTitle } from './common/ScreenScrapeStepTitle';
import styled from 'styled-components';
import { Loader } from 'src/common/components/Loader';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';
import { useState } from 'react';
import { verificationIdParam } from '../../../routes';
import { useSSContext } from './useSSContext';

const Text = styled.p`
  text-align: center;
  margin-bottom: 0.5rem;
`;

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledButton = styled(ScreenScrapeButton)`
  margin-top: auto;
`;

export const ScreenScrapeAmlPopup = () => {
  const ctx = useSSContext();
  const [isLoading, setIsLoading] = useState(false);

  const redirect = () => {
    setIsLoading(true);
    ctx.cancelProcess();
    ctx.closeModal();
  };

  return (
    <>
      <ScreenScrapeStepTitle>Wystąpił błąd</ScreenScrapeStepTitle>
      <Container>
        <Text>
          Twoja sesja została przerwana, ponieważ bank wymaga od Ciebie
          uzupełnienia dodatkowych informacji.
        </Text>
        <Text>
          Zaloguj się do IPKO, uzupełnij brakujące dane i wróć do nas.
        </Text>
        <StyledButton onClick={redirect}>
          {!isLoading ? 'Dalej' : <Loader width={15} height={15} />}
        </StyledButton>
      </Container>
    </>
  );
};
